import apiClient from './client';

export interface UserStreak {
    id: number;
    user_id: number;
    current_streak: number;
    longest_streak: number;
    last_practice_date: string | null;
    total_xp: number;
    today_xp: number;
    /** Streak freezes held; each covers one missed day automatically. */
    streak_freezes: number;
    /** Spendable XP (total_xp minus XP spent on freezes). */
    xp_balance: number;
    freeze_cost: number;
    max_freezes: number;
}

export const streakService = {
    async getMyStreak(): Promise<UserStreak> {
        const { data } = await apiClient.get<UserStreak>('/api/v1/streaks/me');
        return data;
    },
    /** Spends freeze_cost XP on one freeze. Rejects with 409 max_freezes / 402 not_enough_xp. */
    async buyFreeze(): Promise<UserStreak> {
        const { data } = await apiClient.post<UserStreak>('/api/v1/streaks/freeze', {});
        return data;
    },
};
